module.exports = __webpack_public_path__ + "media/preview/future-4a15898b.png";